window.global ||= window;
import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
const superagent = superagentPromise(_superagent, window.global.Promise);
// import environments from './hooks/environments';
import axios from 'axios';
// import _ from 'lodash';

const API_BASE_ROOT = import.meta.env.VITE_AXIOS_BASE_URL_ROOT;
// const API_ROOT_LOCAL = `http://127.0.0.1:8000/api`;
// const API_ROOT_LOCAL = `https://y819qrqotb.execute-api.ap-south-1.amazonaws.com/v1/api`; //dev
const API_ROOT_LOCAL = import.meta.env.VITE_AGENT_API_URL_ROOT; //dev
// const MOCK_API_ROOT_LOCAL = import.meta.env.VITE_APP_AXIOS_BASE_URL_MOCK_ROOT;
//dev
// const API_ROOT_LOCAL = 'http://13.232.179.137:8000/api';  //QA
//const API_ROOT_LIVE = 'http://35.198.206.186:8000/api';
// let tenantID = window.localStorage.getItem('tenantID');
const API_ROOT = API_ROOT_LOCAL;
//const encode = encodeURIComponent;
const responseBody = res => res.body;

// Cookie-based auth: use withCredentials to send cookies automatically
const tokenPlugin = req => {
  req.withCredentials(true);
};

// https://ee132e51-0d16-4285-97b3-9e83446cb717.mock.pstmn.io
// for cloud events web socket => ws://127.0.0.1:8000/ws/cloud_events_update/' + tenant_id + "/
const handleError = err => {
  if (err?.status === 401) {
    const currentPath = window.location.pathname;
    if (currentPath === '/login' || currentPath === '/logout' || currentPath.startsWith('/forgot-password')) {
      return Promise.reject(err);
    }

    (async function () {
      try {
        const config = {
          headers: {
            Accept: '*/*',
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        };

        const res = await axios.post(`${API_BASE_ROOT}/refreshtoken`, { data: {} }, config);
        if (res.data.error === 1) {
          window.localStorage.removeItem('tenantID');
          window.localStorage.removeItem('tenantName');
          window.localStorage.removeItem('User');
          localStorage.clear();
          window.open('/login', '_self');
        }
      } catch (refreshErr) {
        window.localStorage.removeItem('tenantID');
        window.localStorage.removeItem('tenantName');
        window.localStorage.removeItem('User');
        localStorage.clear();
        window.open('/login', '_self');
      }
    })();
  }
  return Promise.reject(err);
};
const cloud_events = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

const rules = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

const compliance_pack = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

const vulnerabilities = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  get: (url, body) => superagent.get(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const risk = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const overview = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const inventory_resources_card = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const key_insights = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const edit_enviroment = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  get: (url, body) => superagent.get(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

const dashboard_new = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  get: (url, body) => superagent.get(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  del: (url, body) => superagent.del(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const inventory = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const environment_monitoring = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const reports = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const policy = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const malware = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const data_security = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const data_base_security = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  get: (url, body) => superagent.get(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
// const helm_command = {
//   get: (url, id) =>
//     superagent.get(`${API_ROOT}${url}?shield_version_id=${id}`).use(tokenPlugin).then(responseBody).catch(handleError),
// };
const jira_notifications = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const viper_ai = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}/conversation`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  get: (url, limit, skip) =>
    superagent
      .get(`${API_ROOT}${url}/conversation?limit=${limit}&skip=${skip}`)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
};
const viper_ai_chat = {
  post: (url, body, query) =>
    superagent
      .post(`${API_ROOT}${url}/conversation/${query}/message`, body)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
  get: (url, query) =>
    superagent
      .get(`${API_ROOT}${url}/conversation/${query}/message`)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
  get_search: (url, query) =>
    superagent
      .get(`${API_ROOT}${url}/conversation/search/${query}`)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
  del: (url, query) =>
    superagent.del(`${API_ROOT}${url}/conversation/${query}`).use(tokenPlugin).then(responseBody).catch(handleError),
  get_progress: (url, conversationId, messageId) =>
    superagent
      .get(`${API_ROOT}${url}/conversation/${conversationId}/message/${messageId}/progress`)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
  post_feedback: (url, conversationId, messageId, body) =>
    superagent
      .post(`${API_ROOT}${url}/conversation/${conversationId}/message/${messageId}/feedback`, body)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
  normal_get: url => superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody).catch(handleError),
};
const kubernetes = {
  put: (url, body) =>
    superagent.put(`${API_ROOT}/v1/kubernetes${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  post: (url, body) =>
    superagent.post(`${API_ROOT}/v1/kubernetes${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  get: (url, body) =>
    superagent.get(`${API_ROOT}/v1/kubernetes${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  del: (url, body) =>
    superagent.del(`${API_ROOT}/v1/kubernetes${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};
const code = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}/v1/code${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

const apiSecurity = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}/api_security${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  v1Post: (url, body) =>
    superagent.post(`${API_ROOT}/v1/api_security${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

const aiSecurity = {
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}/v1/kubernetes/ai-security${url}`, body)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
};

const finOps = {
  post: (url, body) =>
    superagent
      .post(`${API_ROOT}/cloudsecurity/cspm/finops${url}`, body)
      .use(tokenPlugin)
      .then(responseBody)
      .catch(handleError),
};

const data_classification = {
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  get: (url, body) => superagent.get(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

const requests = {
  del: url => superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody).catch(handleError),
  get: url => superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody).catch(handleError),
  withoutTenantIDGet: url => superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody).catch(handleError),
  put: (url, body) => superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  withoutTenantIDPut: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  post: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  withoutTenantIDPost: (url, body) =>
    superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
  postWithQueryParams: (url, body, query) =>
    superagent.post(`${API_ROOT}${url}?${query}`, body).use(tokenPlugin).then(responseBody).catch(handleError),
};

// const API_ROOT_2 = import.meta.env.VITE_API_OCR_ROOT;
// const requests2 = {
//   del: url => superagent.del(`${API_ROOT_2}${url}/${tenantID}`).then(responseBody),
//   get: url => superagent.get(`${API_ROOT_2}${url}/${tenantID}`).then(responseBody),
//   withoutTenantIDGet: url => superagent.get(`${API_ROOT_2}${url}`).then(responseBody),
//   put: (url, body) => superagent.put(`${API_ROOT_2}${url}/${tenantID}`, body).then(responseBody),
//   withoutTenantIDPut: (url, body) => superagent.put(`${API_ROOT_2}${url}`, body).then(responseBody),
//   post: (url, body) => superagent.post(`${API_ROOT_2}${url}/${tenantID}`, body).then(responseBody),
//   withoutTenantIDPost: (url, body) => superagent.post(`${API_ROOT_2}${url}`, body).then(responseBody),
// };

const Auth = {
  current: () => requests.withoutTenantIDGet(`/user`),
  getLoginCode: (email, password) => requests.withoutTenantIDPost(`/login`, { user: { email, password } }),
  login: (email, password, verifycode) =>
    requests.withoutTenantIDPost(`/login`, { user: { email, password, verifycode } }),
  refreshToken: (refresh_token, org_name) =>
    requests.withoutTenantIDPost(`/refreshtoken`, { data: { refresh_token, org_name } }),
  chanagePassword: (username, old_password, new_password, c_password) =>
    requests.withoutTenantIDPost(`/changepassword`, {
      data: { username, old_password, new_password, c_password },
    }),
  forgotPassword: email => requests.withoutTenantIDPost(`/forgotpassword`, { data: { email } }),
  setPassword: (query, password, c_password) =>
    requests.withoutTenantIDPut(`/forgotpassword`, { data: { query, password, c_password } }),
  logout: data => requests.withoutTenantIDPost(`/logout`, { data }),
  // clientLoginToken: (email, password) =>
  // 	requests.post(`/login`, { user: { email, password } }),
  // clientLogin: (email, password, verifycode) =>
  // 	requests.post(`/login`, { user: { email, password, verifycode } }),
  // save: (user) => requests.put(`/user`, { user }),
  registerGcp: ({ provider, orderId, hasToken, signupInfo }) =>
    requests.withoutTenantIDPost(`/gcp/signup`, { provider, orderId, hasToken, signupInfo }),
  registerAws: ({ orgToken, signupInfo }) => requests.withoutTenantIDPost(`/aws/signup`, { orgToken, signupInfo }),
};

const Misc = {
  get_regions: ({ environmentTags, timeFilter, environmentIds }) =>
    requests.post(`/cloudsecurity/cspm/list_regions`, {
      data: {
        filters: {
          scope: environmentTags,
          assessment_time_filter: timeFilter,
          environment_id: environmentIds,
        },
      },
    }),
};
const Kubernetes = {
  get_k8_last_scan: data => kubernetes.post('/last-update', data),
  get_cluster_list: data => kubernetes.post('/list-clusters', data),
  get_cluster_top_row_data: data => kubernetes.post('/dashboard/top-row-cards', data),
  get_k8_inventory_overview_cards: data => kubernetes.post('/resource-status-cards', data),
  get_k8_resource_blocks: data => kubernetes.post('/inventory/service-category-count', data),
  get_attack_path_data: data => kubernetes.post('/dashboard/attack-paths', data),
  get_by_state_data: data => kubernetes.post('/identity/by-state-overview', data),
  get_anomaly_detected_over_time_data: data => kubernetes.post('/identity/anomaly-detected-over-time', data),
  get_containers_with_drift: data => kubernetes.post('/identity/containers-with-drift', data),
  get_recent_findings_data: data => kubernetes.post('/dashboard/findings', data),
  get_identities_data: data => kubernetes.post('/dashboard/identities', data),
  get_most_active_actor: data => kubernetes.post('/dashboard/most-active-actors', data),
  get_identity_overview: data => kubernetes.post('/identity/overview', data),
  get_identity_risk_data: data => kubernetes.post('/identity/risk-breakup', data),
  get_risk_overtime: data => kubernetes.post('/identity/risk-over-time', data),
  get_identity_type_data: data => kubernetes.post('/identity/type-breakup', data),
  get_kubernetes_identity_table: data => kubernetes.post('/identity/resource-table', data),
  get_kubernetes_identity_sideoverlay: data => kubernetes.post('/identity/side-overlay', data),
  get_kubernetes_entitlements_details: data => kubernetes.post('/identity/side-overlay-entitlements', data),

  get_kubernetes_identity_sideoverlay_raw_data: data => kubernetes.post('/identity/side-overlay/raw-config', data),
  get_inventory_table_properties: data => kubernetes.post('/inventory/property-keys-values', data),
  get_identity_table_properties: data => kubernetes.post('/identity/table-properties', data),
  get_kubernetes_inventory_table_data: data => kubernetes.post('/inventory/resource-table', data),
  get_kubernetes_inventory_sideoverlay: data => kubernetes.post('/inventory/resource-table-side-overlay', data),
  get_kubernetes_inventory_security_scan: data => kubernetes.post('/security-scans-side-overlay', data),
  get_kubernetes_inventory_violation: data => kubernetes.post('/violations-side-overlay', data),
  get_kubernetes_inventory_overview: data => kubernetes.post('/cluster_overview_side-overlay', { data }),
  get_kubernetes_network_policy: data => kubernetes.post('/inventory/pod/network-policy', data),
  get_kubernetes_inventory_vulnerability: data => kubernetes.post('/vulnerability-side-overlay', data),
  get_kubernetes_inventory_Secrets: data => kubernetes.post('/inventory/secrets', data),
  get_kubernetes_cluster_sensor_status: data => kubernetes.post('/cluster-side-overlay-sensor_status_cards', { data }),
  get_kubernetes_cluster_sensor_trends: data => kubernetes.post('/cluster-side-overlay-sensor_status_trends', { data }),
  get_kubernetes_cluster_pods: data => kubernetes.post('/cluster-side-overlay-pod_details', { data }),
  get_kubernetes_sensor_status_filters: data => kubernetes.post('/cluster-side-overlay-pod_filter', { data }),
  // compliance
  get_kubernetes_compliance_top_cards: data => kubernetes.post('/compliance/top-row-cards', data),
  get_kubernetes_compliance_trend: data => kubernetes.post('/compliance/trend', data),

  // runtime
  get_kubernetes_runtime_alerts_summary: data => kubernetes.post('/runtime-alerts/summary', data),
  get_kubernetes_runtime_alerts_trends: data => kubernetes.post('/runtime-alerts/trends', data),
  get_kubernetes_runtime_threat_names: () => kubernetes.get('/runtime-alerts/supported-rules'),
  get_kubernetes_runtime_top_threat: data => kubernetes.post('/runtime-alerts/top-threats', data),
  get_kubernetes_runtime_workload_learning_data: data => kubernetes.post('/runtime-alerts/workload-learning', data),
  get_kubernetes_runtime_alerts_list: data => kubernetes.post('/runtime-alerts/list', data),
  get_kubernetes_runtime_alerts_details: data => kubernetes.post('/runtime-alerts/details', data),
  get_kubernetes_runtime_alerts_timeline: data => kubernetes.post('/runtime-alerts/details/timeline', data),
  get_kubernetes_runtime_session_trail_timeline: data => kubernetes.post('/runtime-alerts/session-trail', data),

  get_runtime_filter_data: data => kubernetes.post('/runtime-alerts/filter-values', data),
  create_runtime_alert: data => kubernetes.post('/runtime-alerts/configuration', data),
  create_runtime_alert_detail: data => kubernetes.post('/runtime-alerts/configuration/detail', data),
  get_kubernetes_threat_ai_analyis: data => requests.post('/v1/aiprovider/k8s-threat-analysis', data),
  get_kubernetes_process_tree_graph: data => requests.post('/visualizer/alert-graph', data),
  get_kubernetes_process_tree_graph_alert_details: data => requests.post('/visualizer/alert-details', data),

  // vulnerabilities
  get_vulnerabilities_severity: data => kubernetes.post('/vulnerabilities/summary', data),
  get_vulnerabilities_trend: data => kubernetes.post('/vulnerabilities/trends', data),
  get_vulnerabilities_funnel: data => kubernetes.post('/vulnerabilities/funnel', data),
  get_vulnerabilities_unique_cves_trend: data => kubernetes.post('/vulnerabilities/unique-cves-trend', data),
  get_vulnerabilities_cve_summary: data => kubernetes.post('/vulnerabilities/cve-summary', data),
  get_vulnerabilities_top_public_images_fix_impact: data =>
    kubernetes.post('/vulnerabilities/top-public-images-fix-impact', data),
  get_vulnerabilities_top_packages_fix_impact: data =>
    kubernetes.post('/vulnerabilities/top-packages-fix-impact', data),
  get_vulnerabilities_image_summary: data => kubernetes.post('/images/images-summary', data),
  get_vulnerabilities_unscanned_images_table: data => kubernetes.post('/images/unscanned-images', data),
  get_vulnerabilities_unscanned_images_table_filter: data =>
    kubernetes.post('/images/unscanned-images-filter-values', data),
  get_vulnerabilities_findings_details: data => kubernetes.post('/vulnerabilities-graph', data),
  get_sbom_table_data: data => kubernetes.post('/sbom/list', data),
  get_sbom_table_details: data => kubernetes.post('/sbom/details', data),
  get_image_table_data: data => kubernetes.post('/images/list', data),
  get_images_table_details: data => kubernetes.post('/images/details', data),
  get_images_layers: data => kubernetes.post('/images/layers', data),
  get_images_layers_vuln: data => kubernetes.post('/images/layers/vuls', data),
  get_workloads_table_details: data => kubernetes.post('/workloads/details', data),
  get_workloads_vul_runtime_analysis_table_details: data => kubernetes.post('/workloads/runtime-analysis', data),
  get_cves_table_details: data => kubernetes.post('/vulnerabilities/details', data),
  get_workload_table_data: data => kubernetes.post('/workloads/list', data),
  get_risk_spotlight: data => kubernetes.post('/workloads/risk-spotlight', data),
  get_cve_filter_data: data => kubernetes.post('/vulnerabilities/filter-values', data),
  get_sbom_filter_data: data => kubernetes.post('/sbom/filter-values', data),
  get_images_filter_data: data => kubernetes.post('/images/filter-values', data),
  get_workload_filter_data: data => kubernetes.post('/workloads/filter-values', data),
  get_node_level_details: data => kubernetes.post('/nodes/vuls/list', data),
  get_node_vulns_filter: data => kubernetes.post('/nodes/vuls/filter-values', data),
  get_node_vulns_detail: data => kubernetes.post('/nodes/vuls/details', data),
  check_ec2_eligibility: data => kubernetes.post('/nodes/vuls/eligibility', data),
  get_tag_crown_jewel: data => kubernetes.post('/workloads/crown-jewel/tag', data),
  get_untag_crown_jewel: data => kubernetes.post('/workloads/crown-jewel/untag', data),
  get_workload_cve_trend: data => kubernetes.post('/workload/workload-cve-trend', data),

  //sideoverlay
  get_cve_sideoverlay_keys: data => kubernetes.post('/vulnerabilities/details/property-key-value', data),
  get_workload_sideoverlay_keys: data => kubernetes.post('/workloads/details/property-key-value', data),
  get_sbom_sideoverlay_keys: data => kubernetes.post('/sbom/details/property-key-value', data),
  get_images_sideoverlay_keys: data => kubernetes.post('/images/details/property-key-value', data),
  // scan history
  get_k8s_scan_history_overview: data => kubernetes.post('/k8s-scan-history-overview', data),
  get_k8s_scan_history_list: data => kubernetes.post('/k8s-scan-history-list', data),
  get_k8s_vuln_scan_history_overview: data => kubernetes.post('/k8s-vuln-scan-history-overview', data),
  get_k8s_vuln_scan_history_list: data => kubernetes.post('/k8s-vuln-scan-history-list', data),
  get_k8s_vuln_scan_history_filter: data => kubernetes.post('/k8s-vuln-scan-history-filters', data),

  // seccomp
  get_seccomp_list: data => kubernetes.post('/seccomp-profiles/list', data),
  get_seccomp_sideoverlay: data => kubernetes.post('/seccomp-profiles/details', data),
  get_seccomp_filter_data: data => kubernetes.post('/seccomp-profiles/filter-values', data),

  // Network
  get_network_list: data => kubernetes.post('/network-policy/table-details', data),
  get_network_sideoverlay: data => kubernetes.post('/network-policy/table-details-side-overlay', data),
  get_network_filter_data: data => kubernetes.post('/network-policy/table-details-filters', data),

  // Image Scout
  get_image_scout_sideoverlay_layers: data => kubernetes.post('/images/scout/scout-layers', data),
  get_image_scout_sideoverlay_layers_vuln: data => kubernetes.post('/images/scout/scout-layer-vulns', data),
  get_image_scout_sideoverlay_layers_vuln_filter: data => kubernetes.post('/images/scout/scout-filter-values', data),
  get_image_scout_sideoverlay_images: data => kubernetes.post('/images/scout/scout-images', data),
  get_image_scout_sideoverlay_packages: data => kubernetes.post('/images/scout/scout-packages', data),
  get_image_scout_sideoverlay_summary: data => kubernetes.post('/images/scout/scout-summary', data),

  //risk
  get_risk_table: data => kubernetes.post('/vulnerabilities/exception-list', data),
  create_exception: data => kubernetes.post('/vulnerabilities/exception/create', data),
  get_exception: data => kubernetes.post('/vulnerabilities/exception-get', data),
  delete_exception: data => kubernetes.post('/vulnerabilities/exception/delete', data),
  get_kubernetes_risk_acceptance_filter: data => kubernetes.post('/vulnerabilities/exception-list-filter', data),
  create_bulk_suppression: data => kubernetes.post('/vulnerabilities/exception/bulk-create', data),
  //action history
  get_action_history: data => kubernetes.post('/runtime-alerts/action-history', data),
  // Malware APIs
  get_malware_top_cards: data => kubernetes.post('/malware/top-row-cards', data),
  get_malware_table: data => kubernetes.post('/malware/table', data),
  get_malware_policies_filter_keys: data => kubernetes.post('/malware/auto-enforcement/policies/filter-keys', data),
  get_malware_policies_table: data => kubernetes.post('/malware/auto-enforcement/policies/list', data),
  get_malware_enforcement_history: data => kubernetes.post('/malware/auto-enforcement/history', data),
  get_malware_enforcement_history_filter_keys: data =>
    kubernetes.post('/malware/auto-enforcement/history/filter-keys', data),
  get_malware_details: data => kubernetes.post('/malware/table-details', data),
  get_malware_filters: data => kubernetes.post('/malware/table/filters', data),
  get_malware_details_filters: data => kubernetes.post('/malware/details/all-threats', data),
  get_malware_policy_config: (data, policy_id) => kubernetes.put(`/malware/auto-enforcement/policy/${policy_id}`, data),
  delete_malware_policy: policy_id => kubernetes.del(`/malware/auto-enforcement/policy/${policy_id}`),
  get_malware_auto_suppression_workloads: data => kubernetes.post('/malware/auto-suppression/workloads', data),
  create_malware_auto_suppression_config: data => kubernetes.post('/malware/auto-enforcement/policy', data),
  get_malware_file_search_requests: params =>
    kubernetes.get(`/malware/file-search/requests?$limit=${params.limit}&offset=${params.offset}`),
  get_malware_file_search_results: data => kubernetes.post(`/malware/file-search/results`, data),
  delete_malware_auto_suppression_config: queryString => {
    return kubernetes.del(`/malware/auto-suppression/config?${queryString}`);
  },
  check_eligibility: data => kubernetes.post('/check-eligibility', data),
  create_malware_alert: data => kubernetes.post('/malware/enforcement-alerts/configuration', data),
  get_malware_alert: data => kubernetes.get('/malware/enforcement-alerts/configuration', data),
  get_malware_timeline: value => kubernetes.get(`/malware/auto-enforcement/history/timeline/${value}`),
  malware_enforcement: data => kubernetes.post('/malware/enforcement', data),
  trigger_malware_file_search: data => kubernetes.post('/malware/file-search', data),
  get_enforcement_namespaces: data => kubernetes.post('/runtime/enforcement/namespaces', data),
  get_enforcement_app_names: data => kubernetes.post('/runtime/enforcement/apps', data),

  create_enforcement_policy: data => kubernetes.post('/runtime/enforcement/policy', data),
  list_enforcement_policies: data => kubernetes.post('/runtime/enforcement/policies', data),
  list_enforced_policy: data => kubernetes.post('/runtime/enforcement/threats', data),
  get_enforcement_overview: data => kubernetes.post('/runtime/enforcement/overview', data),
  update_enforcement_policy: data => kubernetes.post('/runtime/enforcement/policy/update', data),
  delete_enforcement_policy: data => kubernetes.post('/runtime/enforcement/policy/delete', data),

  // Workload Application Profile APIs
  get_kubernetes_workload_network_traffic: data => kubernetes.post('/workload/network-traffic', data),
  get_kubernetes_workload_seccomp_endpoints: data => kubernetes.post('/workload/seccomp-endpoints', data),
  get_kubernetes_workload_processes: data => kubernetes.post('/workload/processes', data),
  get_kubernetes_workload_syscalls: data => kubernetes.post('/workload/syscalls', data),
  get_kubernetes_workload_files: data => kubernetes.post('/workload/files', data),
  get_kubernetes_workload_processes_filter_values: data => kubernetes.post('/workload/processes/filter-values', data),
  get_kubernetes_workload_network_traffic_filter_values: data =>
    kubernetes.post('/workload/network-traffic/filter-values', data),
  get_kubernetes_workload_seccomp_endpoints_filter_values: data =>
    kubernetes.post('/workload/seccomp-endpoints/filter-values', data),
  get_kubernetes_workload_syscalls_filter_values: data => kubernetes.post('/workload/syscalls/filter-values', data),
  get_kubernetes_workload_files_filter_values: data => kubernetes.post('/workload/files/filter-values', data),

  // Export / Schedule Report
  get_export_config: ({ environment, cluster }) => {
    const params = new URLSearchParams();

    if (environment) params.append('environment', environment);
    if (cluster) params.append('cluster', cluster);
    return kubernetes.get(`/vulnerabilities/export/?${params.toString()}`);
  },
  schedule_export: data => kubernetes.post('/vulnerability/export/', data),
};

const BulkRemediation = {
  get_bulk_remdiation: data => dashboard_new.post('/bulk-remediation', data),
};

const Cspa = {
  newassessment: (action = ``) =>
    requests.post(`/cloudsecurity/cspm/new_assessment`, {
      data: { action },
    }),
  assessmentdetails: (action = ``) =>
    requests.post(`/cloudsecurity/cspm/assessment_details`, {
      data: { action },
    }),
  check_assessment: (assesment_name = ``) =>
    requests.post(`/cloudsecurity/cspm/checkassesment`, {
      data: { assesment_name },
    }),
  schedule_scan: (data = ``) => requests.post(`/cloudsecurity/cspm/schedule_scan`, { data: data }),
  accounts: (action = ``) => requests.post(`/cloudsecurity/cspm/accounts`, { data: { action } }),
  completed_assessment: (code = ``) =>
    requests.post(`/cloudsecurity/cspm/completed_assessment`, {
      data: { code },
    }),
  get_scan_history: data => requests.post(`/cloudsecurity/cspm/scanhistory1.1/scan-history`, data),
  scan_present: () => requests.post(`/cloudsecurity/cspm/scanhistory1.1/scan-present`),
  get_assessment_time_filter: data =>
    requests.post(`/cloudsecurity/cspm/scanhistory1.1/assessment_time_filter`, { data }),
  get_latest_scan_data: data => requests.post(`/cloudsecurity/cspm/scanhistory1.1/latest-scan`, data),

  scan_repot: data => requests.post(`/cloudsecurity/cspm/scanresult`, { data: data }),
  generateTemplate: data => requests.post(`/cloudsecurity/cspm/generatetemplate`, { data: data }),
  getcloudandcompliancelist: data => requests.post(`/cloudsecurity/cspm/compliancelist`, { data: data }),
  connect_account: data => requests.post(`/cloudsecurity/cspm/connectaccount`, { data: data }),
  list_account: data => requests.post(`/cloudsecurity/cspm/listaccount`, { data: data }),
  list_environments: data => requests.post(`/cloudsecurity/cspm/listenvironments`, { data: data }),
  update_account: data => requests.post(`/cloudsecurity/cspm/updateaccount`, { data: data }),
  delete_account: data => requests.post(`/cloudsecurity/cspm/deleteaccount`, { data: data }),
  get_date_account_creation: data => requests.post(`/cloudsecurity/cspm/getaccountdate`, { data: data }),
  generate_external_id: data => requests.post(`/cloudsecurity/cspm/getexternalid`, { data: data }),
  generate_teraform: data => requests.post(`/cloudsecurity/cspm/teraform`, { data: data }),
  unique_name: data => requests.post(`/cloudsecurity/cspm/verifyenv`, { data: data }),
  get_orgranization_modules: data => requests.post(`/cloudsecurity/cspm/check-organization-modules`, data),
  get_onboarding_status: data => requests.post(`/cloudsecurity/cspm/onboarding-status`, data),
  fetch_risk_remediation: data => requests.post(`/cloudsecurity/cspm/risk1.2/risk_remediation`, { data: data }),
  compliance_report: data => requests.post(`/cloudsecurity/cspm/allcompliance`, { data: data }),
  compliance_dashboard: data => requests.post(`/cloudsecurity/cspm/allnewcompliance`, { data: data }),
  compliance_breakdown: data => requests.post(`/cloudsecurity/cspm/individualcompliance`, { data: data }),
  scan_history_report: data => requests.post(`/cloudsecurity/cspm/scanhistory`, { data: data }),
  // API for Scan Reports
  history_report_by_id: data => requests.post(`/cloudsecurity/cspm/historybyid`, { data: data }),
  export_env_report_by_id: data => requests.post(`/cloudsecurity/cspm/env-report-export`, { data: data }),
  scan_report_resource_aws_config: data => requests.post(`/cloudsecurity/cspm/resourcedetail`, { data: data }),
  scan_report_resource_type_expand: data => requests.post(`/cloudsecurity/cspm/historybyresource`, { data: data }),
  scan_report_controls_expand: data => requests.post(`/cloudsecurity/cspm/historybycontrol`, { data: data }),
  scan_report_resource_by_type_expansion: data =>
    requests.post('/cloudsecurity/cspm/scan_report/compliance_by_resource_type_expansion', { data }),
  // Remediation APIS
  remediation_steps_data: data => requests.post(`/cloudsecurity/cspm/stepsbyrule`, { data: data }),
  remediation_scan: data => requests.post(`/cloudsecurity/cspm/remediatenow`, { data: data }),
  remediation_scan_result: data => requests.post(`/cloudsecurity/cspm/remediationreport`, { data: data }),
  // API for Risk
  risk_report_table_data: data => requests.post(`/cloudsecurity/cspm/detailbyrisk`, { data: data }),
  risk_report_expand_data: data => requests.post(`/cloudsecurity/cspm/expandriskdata`, { data: data }),
  // Rules
  rules_table: data => requests.post(`/cloudsecurity/cspm/ruledata`, { data }),
  service_rules: data => requests.post(`/cloudsecurity/cspm/listrules`, { data }),
  // Configure-rules
  configure_whitelist: data => requests.post(`/cloudsecurity/cspm/manualrule`, { data }),
  configure_whitelist_submit: data => requests.post(`cloudsecurity/cspm/addmanualruledata`, { data }),
  exceptions: data => requests.post(`/cloudsecurity/cspm/ruleexceptions`, { data }),
  update_exceptions: data => requests.post(`/cloudsecurity/cspm/updateexceptions`, { data }),
  list_exceptions: data => requests.post(`/cloudsecurity/cspm/listexceptions`, { ...data }),
  revoke_exceptions: data => requests.post(`/cloudsecurity/cspm/revokeexception`, { data }),
  exceptions_risk: data => requests.post(`/cloudsecurity/cspm/exceptiondetails`, { data }),
  fetch_exceptions_by_resource: data => requests.post(`/cloudsecurity/cspm/exception-by-resource-table`, { data }),
  // Services
  services_table: data => requests.post(`/cloudsecurity/cspm/listservices`, { data }),
  report_summary: data => requests.post(`/cloudsecurity/cspm/quick_summary`, { data }),
  create_report_from_admin: data => requests.post(`/admin/reports`, data),
  get_exceptions: data => requests.post(`/cloudsecurity/cspm/exception-risk-detail`, data),
  get_exception_table_filter: data => requests.post(`/cloudsecurity/cspm/risk-exception/property-key-value`, data),
  get_exception_expansion_data: data => requests.post(`/cloudsecurity/cspm/exception-risk-expand-data`, data),
  get_cluster_version_list: data => requests.post(`/cloudsecurity/cspm/shield-versions`, data),
  get_rtm_config_update: data => requests.post(`/cloudsecurity/cspm/get_module_configuration`, data),
  update_metadata: data => requests.post(`/cloudsecurity/cspm/update_kubernetes_metadata`, { data }),
  // get_helm_data: id => helm_command.post(`/cloudsecurity/cspm/shield-versions`, id),
  get_helm_docker_values: () => requests.post(`/cloudsecurity/cspm/helm-docker-values`),
  get_active_exeception: data => requests.post('/cloudsecurity/cspm/exception-by-resource-table', { data }),
};
const limit = (count, p) => `limit=${count}&offset=${p ? p * count : 0}`;
const omitSlugClient = client => Object.assign({}, client, { slug: undefined });
const Clients = {
  all: page => requests.get(`/clients?${limit(10, page)}`),
  del: slug => requests.del(`/clients/${slug}`),
  chunk: page => requests.get(`/clients?${limit(10, page)}`),
  get: slug => requests.get(`/clients/${slug}`),
  update: client => requests.put(`/clients/${client.slug}`, { client: omitSlugClient(client) }),
  create: client => requests.post(`/clients`, { client }),
};
const Phishing = {
  get_sp: () => requests.get(`/peopleawareness/sendingprofile`),
  get_template: () => requests.get(`/peopleawareness/templates`),
  get_landing: () => requests.get(`/peopleawareness/landingpages`),
  get_usergroups: data => requests.get(`/peopleawareness/usersandgroups`, { data: { data } }),
  get_clients: () => requests.get(`/getClients`),
  create_sp: (formdata, action, currentuser) =>
    requests.post(`/peopleawareness/sendingprofile`, {
      data: { formdata, action, currentuser },
    }),
  create_group: (currentuser, formadata, action) =>
    requests.post(`/peopleawareness/usersandgroups`, {
      data: { currentuser, formadata, action },
    }),
  create_campaign: (formdata, action, channel, currentuser) =>
    requests.post(`/peopleawareness/campaigns`, {
      data: { formdata, action, channel, currentuser },
    }),
  phised_users: data => requests.post(`/peopleawareness/phishedusers`, { data: { data } }),
  download_report: (formdata, action, channel) =>
    requests.post(`/peopleawareness/reports`, {
      data: { formdata, action, channel },
    }),
  create_rp: (formdata, action) =>
    requests.post(`/peopleawareness/reportingprofile`, {
      data: { formdata, action },
    }),
  last_15_campaigns: (data, currentuser) =>
    requests.post(`/peopleawareness/last15campaigndata`, {
      data: { data, currentuser },
    }),
  phished_userwise: data => requests.post(`/peopleawareness/phisheddatauserswise`, { data: { data } }),
  phished_groupwise: data => requests.post(`/peopleawareness/phisheddatagroupswise`, { data: { data } }),
  phished_user_maindashboard: data =>
    requests.post(`/peopleawareness/phisheddatamaindashboard`, {
      data: { data },
    }),
  phished_risk_posture_group_maindashboard: data =>
    requests.post(`/peopleawareness/phishedriskposturedatamaindashboard`, {
      data: { data },
    }),
  phished_users_last12months: data =>
    requests.post(`/peopleawareness/last12monthsphishedusers`, {
      data: { data },
    }),
  phished_groups_last12months: data =>
    requests.post(`/peopleawareness/last12monthsphishgroups`, {
      data: { data },
    }),
  userwise_last12months: (data, email) =>
    requests.post(`/peopleawareness/last12monthsuserwise`, {
      data: { data, email },
    }),
  groupwise_last12months: (data, name) =>
    requests.post(`/peopleawareness/last12monthsgroupwise`, {
      data: { data, name },
    }),
  template_data: (formdata, action, currentuser) =>
    requests.post(`/peopleawareness/templates`, {
      data: { formdata, action, currentuser },
    }),
  // update: client =>
  //   requests.put(`/clients/${client.slug}`, { client: omitSlugClient(client) }),
  // create: client =>
  //   requests.post('/clients', { client })
};
const ClientDashboard = {
  get_help: () => requests.post('/gitbook/signed-url'),
  get_dashboard: org => requests.get(`/dashboard?org=` + org),
  create_organization: formadata => requests.post(`/registration`, { data: formadata }),
  activate_user: formadata => requests.post(`/activate`, { data: formadata }),
  // chanage_password: (formadata) =>
  // 	requests.post(`/changepassword`, { data: formadata }),
  client_login: formadata => requests.post(`/login`, { data: formadata }),
  partner_login: api_key => requests.post(`/partner/login`, { data: { api_key: api_key } }),
};

const OCR = {
  get_policy_meta: () =>
    requests.post(`/policy-meta`, {
      environment_id: '',
      master_rule_id: '',
      regions: '',
      scan_id: '',
      resource_id: '',
      resource_type: '',
      scope_environment_id: [],
    }),
  get_policy_meta_for_single_rule: (ruleId, environmentId, scope_environment_id, resource_id, resource_type, regions) =>
    requests.post(`/policy-meta`, {
      master_rule_id: ruleId,
      environment_id: environmentId,
      scope_environment_id: [scope_environment_id],
      resource_id: resource_id,
      resource_type: resource_type,
      regions: regions,
      scan_id: '',
    }),
  get_resources: data => requests.post(`/fetch-resource`, data),
  create_policy: payload => requests.post(`/save-policy`, payload),
  update_policy: ({ id, payload, updatedBy }) => requests.post(`/update-policy`, { id, username: updatedBy, payload }),
  fetch_policy_by_policy_id: policyId =>
    requests.post('/fetch-policy', {
      policy_id: policyId,

      date_filter: '',
      scope: ['Global'],
      all_resource: {
        resource_type: [],
        service: [],
        service_category: [],
      },
      cloud_provider: '',
      scope_environment_id: [],
      properties_filter: {
        rule_id: [],
        region: [],
        severity: [],
        user_groups: [],
        match: 'any',
      },
      unique_id: '121',
      search_keyword: '',
      page_no: 1,
      row_per_page: 1000,
    }),
  revoke_policy: (id, payload) =>
    requests.post(`/delete-policy`, {
      id,
      username: payload.created_username,
      user_email: payload.created_user_email,
    }),
  trigger_remediation: payload => requests.post('/remediate', payload),
  get_remediation: id => requests.post('/remediation-reports', { remediation_id: id }),
  fetch_remediations: payload => requests.post('/remediation-reports', payload),
  fetch_remediations_by_ids: remediation_ids =>
    requests.post('/remediation-reports', {
      data: {
        all_resource: {
          resource_type: [],
          service: [],
          service_category: [],
        },
        cloud_provider: localStorage.getItem('cp_for_remediation'),
        date_filter: '24 hours',
        environments: [],
        event_type: 'Remediation',
        remediation_id: remediation_ids,
        page_no: 1,
        properties_filter: {
          match: 'Any',
          rule_id: [],
          severity: [],
          status: [],
          trigger: [],
        },
        row_per_page: 10,
        scope: ['Global'],
        search_keyword: '',
        unique_id: '121',
      },
    }),
  fetch_policy_names: () => requests.post('/get-policy-name', {}),
};

const Environment = {
  fetch_environments_and_cloud_providers: () => requests.get('/cloudsecurity/cspm/fetchglobalfilter'),
};

const Environment_Monitoring = {
  get_monitoring_error_message: data =>
    environment_monitoring.post(`/cloudsecurity/cspm/monitoring-error-msg`, { data }),
};

const Identity = {
  get_compliance_control_info: () => requests.post(`/compliance-control-info`),
  get_compliance_control_info_for_account: (environmentIds, scanId) =>
    requests.post(`/compliance-control-info-per-account`, {
      account_id: environmentIds,
      scan_id: scanId,
    }),
  get_identity_iam_info: (environmentIds, scanId) =>
    requests.post(`/identity_iam_info`, {
      account_id: environmentIds,
      scan_id: scanId,
    }),
  get_identity_intelligence_identities: (environmentIds, scanId) =>
    requests.post(`/top_row_data`, { account_id: environmentIds, scan_id: scanId }),
  /**
   *
   * @param {*} environmentIds [123123, 234234, 345345]
   * @param {*} fromDate yyyy-mm-dd
   * @returns
   */
  get_identity_trend_overview: (environmentIds, period, timezone, scanId) =>
    requests.post('/dashboard_trend_info', {
      account_id: environmentIds,
      period,
      timezone,
      scan_id: scanId,
    }),
  get_identity_severity_breakup: (environmentIds, scanId) =>
    requests.post('/identity_severity_breakup', {
      environments: environmentIds,

      scan_id: scanId,
    }),

  get_identities_top_row_data: ({ environmentIds, type, scanId }) =>
    requests.post('/identities_top_row', {
      account_id: environmentIds,
      type,
      scan_id: scanId,
    }),
  get_identity_meta_data: ({ id, type, scan_id }) =>
    requests.post('/identity-metadata', {
      type,
      id,
      scan_id,
    }),

  /**
   *
   * @param {*} environmentIds
   * @param {*} type policies|users|roles|groups
   * @param {*} page
   * @param {*} page_size
   * @returns
   */
  get_identities_table_data: ({
    environmentIds,
    filter,
    type,
    export: isExport,
    shield_severity,
    page,
    page_size,
    filter_operator,
    regex,
    scanId,
  }) =>
    requests.post('/identities_table_data_v2', {
      filters: { accountId: environmentIds, ...filter },
      type,
      page,
      export: isExport,
      page_size,
      filter_operator,
      regex,
      scan_id: scanId,
      ...(shield_severity && { shield_severity: shield_severity }),
    }),

  get_identities_action_data: (id, scan_id, type) =>
    requests.post('/identities_action', {
      id,
      scan_id,
      type,
    }),
  get_identity_summary: data => requests.post('/summary', data),
  get_identity_entitlements: data => requests.post('/entitlements', data),
  get_trust_policy_data: data => requests.post('/trust_relationship', data),
  entitlements_action: data => requests.post('/entitlements_action', data),
  get_idp_topcards: data => requests.post('/identity_providers_top_row_cards', data),
  get_identity_providers: data => requests.post('/identity_providers', data),
  get_idp_filter_keys: data => requests.post('/identity_providers/filter', data),
  risk_analysis: data => requests.post('/risk_analysis', data),
  get_optimal_policy: (type, cloud_provider) =>
    requests.post('/remediation_step', {
      type,
      cloud_provider,
    }),
  get_identity_service_entitlements_analysis: data =>
    requests.post('/v1/aiprovider/service-entitlements-analysis', data),

  get_assessment_times: (environmentIds, dateFilter) => {
    return requests.post('/assessment_times', {
      environments: environmentIds,
      date_filter: dateFilter,
    });
  },
  get_vulnerable_assessment_times: data => {
    return requests.post('/cloudsecurity/cspm/vulnerable_assessment_times', data);
  },
  get_identity_anamoly_threats: (
    selectedEnvironmentTags,
    environmentIds,
    cloudProvider,
    selectedAssessmentTime,
    timeFilter,
  ) => {
    return requests.post(`/identity_anomaly_threat`, {
      scope: selectedEnvironmentTags,
      environments: environmentIds,
      cloud_provider: cloudProvider,
      assessment_time_filter: selectedAssessmentTime,
      date_filter: timeFilter,
    });
  },
  get_identity_attack_path: (
    selectedEnvironmentTags,
    environmentIds,
    cloudProvider,
    selectedAssessmentTime,
    timeFilter,
    scan_id,
  ) => {
    return requests.post(`/identity_attack_path`, {
      scope: selectedEnvironmentTags,
      environments: environmentIds,
      cloud_provider: cloudProvider,
      assessment_time_filter: selectedAssessmentTime,
      date_filter: timeFilter,
      scan_id: scan_id,
    });
  },
  get_identity_top_risk_identities: (
    selectedEnvironmentTags,
    environmentIds,
    cloudProvider,
    selectedAssessmentTime,
    timeFilter,
    scan_id,
  ) => {
    return requests.post(`/risk_identity_shield_priority`, {
      scope: selectedEnvironmentTags,
      environments: environmentIds,
      cloud_provider: cloudProvider,
      assessment_time_filter: selectedAssessmentTime,
      date_filter: timeFilter,
      scan_id: scan_id,
    });
  },
  get_identity_non_human_identity_top_issues: data => requests.post(`/nhi_top_issues`, data),
  get_identity_non_human_identity_dashboard_cards: data => requests.post(`/nhi_dashboard_cards`, data),
  get_identity_non_human_identity_risky_service_accounts: data => requests.post(`/nhi_risky_service_accounts`, data),
  get_identity_non_human_identity_sensitive_data_access: data => requests.post(`/nhi_sensitive_data_access`, data),
  get_identity_non_human_identity_lateral_movement_risk: data => requests.post(`/nhi_lateral_movement_risk`, data),
  get_identity_non_human_identity_activity_by_country: data => requests.post(`/nhi_activity_by_country`, data),
  get_identity_non_human_identity_third_party_vendors: data => requests.post(`/nhi_third_party_vendors`, data),
  get_identity_non_human_identity_findings: data => requests.post(`/nhi_findings`, data),
  get_identity_non_human_identity_findings_filter: data => requests.post(`/nhi_findings/filter`, data),
};

const Visualization = {
  /**
   *
   * @param {*} param0
   * @param {*} param0.accountIds string[]
   * @param {*} param0.nodeId string
   * @param {*} param0.page number starting from 1 (optional)
   * @param {*} param0.limit number (optional)
   * @returns
   */
  get_nodes: ({ accountIds, nodeId, filter, page, limit, search_key, show_category }) =>
    requests.post('/visualizer', {
      accountId: accountIds ? accountIds : [],
      id: nodeId !== undefined && nodeId !== null ? [nodeId] : [],
      // groupBy: true,
      filter: filter,
      search_key: search_key,
      show_category: show_category,
      // regions: ['global'],
      ...(page !== undefined && { offset: (page - 1) * limit }),
      ...(limit !== undefined && page !== undefined && { limit }),
    }),

  get_nodes_identity: ({
    region,
    id,
    resource_type,
    account_id,
    node_service_id,
    node_service,
    node_resource_type,
    page,
    limit,
    node_resource_id,
  }) =>
    requests.post('/visualizer/identity/graph', {
      ...(region && { region: region }),
      ...(node_service_id && { node_service_id: node_service_id }),
      ...(node_service && { node_service: node_service }),
      ...(node_resource_type && { node_resource_type: node_resource_type }),
      ...(node_resource_id && { node_resource_id: node_resource_id }),
      region: region ? region : [],
      id: id,
      // groupBy: true,
      resource_type: resource_type,
      account_id: account_id,

      // regions: ['global'],
      ...(page !== undefined && { offset: (page - 1) * limit }),
      ...(limit !== undefined && page !== undefined && { limit }),
    }),

  get_nodes_inventory: ({
    region,
    id,
    resource_type,
    account_id,
    // scan_id,
    node_service_id,
    node_service,
    node_resource_type,
    page,
    limit,
    node_resource_id,
  }) =>
    requests.post('/visualizer/resource/expose/graph', {
      ...(region && { region: region }),
      ...(node_service_id && { node_service_id: node_service_id }),
      ...(node_service && { node_service: node_service }),
      ...(node_resource_type && { node_resource_type: node_resource_type }),
      ...(node_resource_id && { node_resource_id: node_resource_id }),
      region: region ? region : [],
      id: id,
      // groupBy: true,
      resource_type: resource_type,
      account_id: account_id,
      // scan_id: scan_id,
      // regions: ['global'],
      ...(page !== undefined && { offset: (page - 1) * limit }),
      ...(limit !== undefined && page !== undefined && { limit }),
    }),
};

const Visualization_Filter = {
  filter: data => requests.post(`/visualizer/filter`, data),
  get_query: () => requests.get(`/visualizer/queries/pre-defined`),
  get_node_data: data => requests.post(`/visualizer/queries/pre-defined`, data),
};

// Attack Path Analysis v2: paths published by the attack path scanner (CSPM_Backend apps/attack_paths).
const ATTACK_PATHS_V2 = '/cloudsecurity/cspm/attack_paths_2.0';
const AttackPathsV2 = {
  list: data => requests.post(`${ATTACK_PATHS_V2}/attack_paths_list`, data),
  summary: data => requests.post(`${ATTACK_PATHS_V2}/attack_paths_summary`, data),
  filterValues: data => requests.post(`${ATTACK_PATHS_V2}/attack_paths_filter_values`, data),
  detail: data => requests.post(`${ATTACK_PATHS_V2}/attack_paths_detail`, data),
  suppress: data => requests.post(`${ATTACK_PATHS_V2}/attack_paths_suppress`, data),
  contain: data => requests.post(`${ATTACK_PATHS_V2}/attack_paths_contain`, data),
};

const AttackPathAnalysis = {
  get_data: data => requests.post(`/cloudsecurity/cspm/main_dashboard1.1/active_attack_path`, data),
  attack_path_property_list: ({
    environmentIds,
    page_no,
    row_per_page,
    search_key,
    filter_particular_key,
    previous_filter,
  }) =>
    requests.post(`/cloudsecurity/cspm/main_dashboard1.1/attack_path_property_list`, {
      environments: environmentIds,
      page_no: page_no,
      row_per_page: row_per_page,
      search_key: search_key,
      filter_particular_key: filter_particular_key,
      previous_filter: previous_filter,
    }),

  get_side_overlay_data: ({
    account_id,
    scan_id,
    severity,
    rule_id,
    rule_name,
    resource_id,
    resource_type,
    region,
    attack_path_payload,
  }) =>
    requests.post(`/cloudsecurity/cspm/main_dashboard1.1/attack_path_side_overlay`, {
      account_id,
      scan_id,
      severity,
      rule_id,
      rule_name,
      resource_id,
      resource_type,
      region,
      attack_path_payload,
    }),

  get_attack_path_graph_data: ({ account_id, resource_id, region, rule_id, resource_type, attack_path_payload }) =>
    requests.post(`/visualizer/attack-path/graph`, {
      rule_id: rule_id,
      region,
      id: resource_id,
      account_id: account_id,
      resource_type,
      attack_path_payload,
    }),
};

const Integration = {
  slack: webhook_url => requests.post(`/alerts/config-channels`, { data: { webhook_url } }),
  channel_integration: data => requests.post(`/alerts/config-channels`, data),
  channelDetails: () => requests.post(`/alerts/config-channels`),
  updateChannelDetails: data => requests.post(`/alerts/config-channels`, data),
  slack_enable_disable: data => requests.post(`/alerts/config-channels`, { data }),
  get_iac_repository_onbarding_status: () => requests.post(`/cloudsecurity/iac/iac_repository_onboarding_status`),
  get_checkmarx_config: () => requests.get(`/code_security/checkmarx/checkmarx-config`),
  get_available_scanners: () => requests.get(`/scanner/available`),
  get_current_active_scanner: () => requests.get(`/scanner/activate`),
};
const notification_setting = {
  fetch_notifications: data => requests.post(`/alerts/fetch-notifications`, { data }),
};
const notification_logs = {
  fetch_notifications_logs: data => requests.post(`/alerts/get-notification-log`, data),
};
const Users = {
  get_users_list: ({ filters, currentPage, pageSize }) =>
    requests.postWithQueryParams(
      `/users_list`,
      { data: { filters: filters } },
      `page=${currentPage}&page_size=${pageSize}`,
    ),
  get_groups_list: ({ filters, currentPage, pageSize }) =>
    requests.postWithQueryParams(
      `/groups`,
      { data: { filters: filters } },
      `page=${currentPage}&page_size=${pageSize}`,
    ),
};
const Compliance = {
  get_average_score: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/average_score`, { data }),
  get_non_compliant_rules_by_severity: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/non_compliant_rules_by_severity`, { data }),
  get_resource_compliance: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/resource_compliance`, { data }),
  get_rule_compliance: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/rule_compliance`, { data }),
  get_resources_count: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/resources_count`, { data }),
  get_non_compliant_resources_graph: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/non_compliant_resources_graph`, { data }),
  get_resource_trend_graph: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/resources_trend_graph`, { data }),
  get_remediation_exception_graph: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/remediation_exception_graph`, { data }),
  get_over_time_graph: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/over_time_graph`, { data }),
  get_last_update: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/last_update`, { data }),
  get_service_category: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/service_category`, { data }),
  get_export: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/export`, { data }),
  get_compliance_by_framework: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/compliance_by_framework`, { data }),
  get_compliance_family_filter: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/compliance_family_filter`, { data }),
  get_control_test: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/control_test`, { data }),
  get_environment: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/environment`, { data }),
  get_table_data_filter: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/table_data_filter`, { data }),
  get_table_data: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/table_data`, { data }),
  get_expansion_data: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/expansion_data`, { data }),
  get_control_evaluation_count: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/control_evaluation_count`, { data }),
  get_export_table_data: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/export_data`, { data }),
  get_export_compliance_data: data => requests.post(`/cloudsecurity/cspm/compliance_v1.1/export`, { data }),
  get_assessment_time_filter: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/assessment_time_filter`, { data }),
  get_compliance_account: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/fetch_compliance_account`, { data }),
  get_custom_frameworks_catalog: data =>
    requests.post(`/cloudsecurity/cspm/custom_compliance/custom_framework_catalog`, { data }),
  get_custom_frameworks_details: data =>
    requests.post(`/cloudsecurity/cspm/custom_compliance/custom_framework_detail`, { data }),
  get_custom_frameworks_rules: data =>
    requests.post(`/cloudsecurity/cspm/custom_compliance/custom_framework_rules`, { data }),
  get_custom_frameworks_create: data =>
    requests.post(`/cloudsecurity/cspm/custom_compliance/custom_framework_create`, { data }),
  get_custom_frameworks_update: data =>
    requests.post(`/cloudsecurity/cspm/custom_compliance/custom_framework_update`, { data }),
  get_custom_frameworks_publish: data =>
    requests.post(`/cloudsecurity/cspm/custom_compliance/custom_framework_publish`, { data }),
};

// Custom compliance frameworks. Paths are placeholders until the BE contract is final;
// the UI reaches these through containers/compliance/customFramework/api.js.
const CUSTOM_FRAMEWORK_ROOT = `/cloudsecurity/cspm/compliance_v1.1/custom_framework`;
const CustomFramework = {
  list: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/list`, { data }),
  get: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/get`, { data }),
  update_details: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/update_details`, { data }),
  import_preview: ({ framework_id, mode, file }) => {
    const formData = new FormData();
    formData.append('framework_id', framework_id);
    formData.append('mode', mode);
    formData.append('file', file);
    return requests.post(`${CUSTOM_FRAMEWORK_ROOT}/import`, formData);
  },
  import_template: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/import_template`, { data }),
  save_structure: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/save_structure`, { data }),
  rule_library: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/rule_library`, { data }),
  save_mappings: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/save_mappings`, { data }),
  validate: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/validate`, { data }),
  publish: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/publish`, { data }),
  edit: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/edit`, { data }),
  discard: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/discard`, { data }),
  delete: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/delete`, { data }),
  versions: data => requests.post(`${CUSTOM_FRAMEWORK_ROOT}/versions`, { data }),
};

const CloudEvents = {
  get_critical_threat_events: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/critical_threat_events`, data),
  get_more_critical_vulnerability: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/more_critical_vulnerability`, data),
  get_anomalous_cloudtrail: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/anomalous_cloudtrail`, data),
  get_anomalous_mitre: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/anomalous_mitre`, data),
  get_threat_by_severity: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/threats`, data),
  get_top_ten_failed_category: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/top_ten_failed_category`, data),
  get_top_ten_category: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/top_ten_category`, data),
  get_events: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/events`, data),
  get_top_ten_drift_events: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/top_ten_drift_events`, data),
  get_delete_events_overtime: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/top_ten_deleted_events_overtime`, data),
  get_events_config: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/events_config`, data),
  get_all_events_default_time_range_config: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/all_events_default_time_range`, data),
  get_list_events: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/list_events`, data),
  get_justified_events: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/get_justified_events`, data),
  get_justified_events_property_keys: () =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/justified_events_property_keys`),
  get_justified_events_property_value: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/justified_events_property_values`, data),
  get_list_events_threats: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/list_events_threats`, data),
  get_events_over_time: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/events_over_time`, data),
  get_remediation_over_time: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/remediation_over_time`, data),
  get_drift_events: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/drift_events`, data),
  get_events_type: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/events_type`, data),
  get_details_list_threats: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/events/details`, data),
  get_activity_list_threats: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/get_activity_details`, data),
  get_event_filter_property_keys: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/property_keys`, data),
  get_event_filter_property_values: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/property_values`, data),
  get_event_filter_service_category: data => {
    const { tab, ...prevData } = data;
    return cloud_events.post(
      `${
        tab === 'Remediation'
          ? '/cloudsecurity/cspm/cloud_events_1.1/event_filter_service_category'
          : '/cloudsecurity/cspm/cloud_events_1.1/event_filter_service_category'
      }`,
      prevData,
    );
  },
  get_event_type_count: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.2/each_event_type_count`, data),
  get_event_filter_service_category_policies: data =>
    cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/event_filter_service_category_policies`, { data }),
  get_last_update: data => cloud_events.post(`/cloudsecurity/cspm/cloud_events_1.1/last_update`, data),
  get_threat_stories_funnel_summary: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_stories_summary`, data),
  get_threat_stories_top_5: data =>
    cloud_events.post(`/cloudsecurity/cspm/main_dashboard1.1/threat_stories_top_5`, data),
  get_threat_stories_table: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/list_threat_stories`, data),
  get_threat_stories_filter_values: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_story_filter_values`, data),
  get_threat_stories_action: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_story_actions`, data),
  get_threat_story_narrative: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_story_detail`, data),
  get_threat_story_agent_investigation: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_story_agent_investigation`, data),
  get_threat_story_detection_timeline: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_story_detection_timeline`, data),
  get_threat_story_raw_configuration: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_story_raw_configuration`, data),
  get_threat_story_for_alert: data =>
    cloud_events.post(`/cloudsecurity/cspm/threat_stories_1.0/threat_story_for_alert`, data),
};

const Rules = {
  get_service_rule_mapping: data => rules.post(`/cloudsecurity/cspm/rules1.1/service_rule_mapping`, { data }),
  get_last_updated: data => rules.post(`/cloudsecurity/cspm/rules1.1/last_updated`, { data }),
  get_rules_table: data => rules.post(`/cloudsecurity/cspm/rules1.1/rules_table`, { data }),
  get_rules_table_expansion: data => rules.post(`/cloudsecurity/cspm/rules1.1/rules_table_expansion`, { data }),
  get_filter_property_values: data => rules.post(`/cloudsecurity/cspm/rules1.1/filter_property_values`, { data }),
  get_rule_type: data => rules.post(`/cloudsecurity/cspm/rules1.1/ruletype`, { data }),
  rule_drill_down: data => rules.post(`/cloudsecurity/cspm/rules1.1/rule_drill_down`, data),
  rulesbyseverity: data => rules.post(`/cloudsecurity/cspm/rules1.1/rulesbyseverity`, data),
  rulescoverage: data => rules.post(`/cloudsecurity/cspm/rules1.1/rulescoverage`, data),
};

const Vulnerabilites = {
  get_vulnerability_risk_spotlight: data =>
    vulnerabilities.post(`/cloudsecurity/cspm/vulnerability-risk-spotlight`, data),
  get_vulnerability_details: data => vulnerabilities.post(`/cloudsecurity/cspm/vulnerability-details`, data),
  get_vulnerability_data: data => vulnerabilities.post(`/cloudsecurity/cspm/vulnerability-data`, data),
  get_resources_data: data => vulnerabilities.post(`/cloudsecurity/cspm/shield-resource-details`, data),
  get_images_data: data => vulnerabilities.post(`/cloudsecurity/cspm/shield-image-details`, data),
  get_images_property_values: data =>
    vulnerabilities.post(`/cloudsecurity/cspm/shield-image-details-property-values`, data),
  get_sbom_property_values: data =>
    vulnerabilities.post(`/cloudsecurity/cspm/shield-artifacts-details-property-values`, data),
  get_sbom_data: data => vulnerabilities.post(`/cloudsecurity/cspm/shield-artifacts-details`, data),
  get_vulnerability_datak8: data => vulnerabilities.post(`/v1/kubernetes/vulnerabilities/list`, data),
  get_k8_cves_list: data => vulnerabilities.post(`/v1/kubernetes/vulnerabilities/cves-list`, data),
  get_k8_cves_filter_values: data => vulnerabilities.post(`/v1/kubernetes/vulnerabilities/cves-filter-values`, data),
  get_k8_cves_details: data => vulnerabilities.post(`/v1/kubernetes/vulnerabilities/cves-details`, data),
  get_vulnerability_datak8_export: data => vulnerabilities.post(`/v1/kubernetes/vulnerabilities/export`, data),

  get_k8_cve_schedule_config: ({ environment, cluster, cloud_provider } = {}) => {
    const params = new URLSearchParams();
    if (environment) params.append('environment', environment);
    if (cluster) params.append('cluster', cluster);
    if (cloud_provider) params.append('cloud_provider', cloud_provider);
    const qs = params.toString();
    return vulnerabilities.get(`/v1/kubernetes/vulnerabilities/export${qs ? `?${qs}` : ''}`);
  },
  schedule_k8_cve_report: data => vulnerabilities.post(`/v1/kubernetes/vulnerabilities/export`, data),

  get_filter_data: data => vulnerabilities.post(`/cloudsecurity/cspm/vulnerability-filter-suggestion`, data),
  get_resource_filter_data: data => vulnerabilities.post(`/cloudsecurity/cspm/shield-resource-filter`, data),
  get_resource_data: data => vulnerabilities.post(`/cloudsecurity/cspm/resource-data`, data),
  get_export_data: data => vulnerabilities.post(`/cloudsecurity/cspm/workload-vulnerabilities-export`, data),
  get_viper_ai_data: data => vulnerabilities.post(`/api/v1/aiprovider/workload/26`, data),
  get_exception_resources_list: data => vulnerabilities.post(`/cloudsecurity/cspm/exception-resources`, data),
  get_workload_images_layers: data => vulnerabilities.post('/cloudsecurity/cspm/ecs-image-layers', data),
  get_workload_images_layers_vulns: data => vulnerabilities.post('/cloudsecurity/cspm/ecs-image-layers-vuls', data),

  get_management_summary: data => vulnerabilities.post('/cloudsecurity/cspm/vulnerability/summary', data),
  get_runtime_exploit_funnel: data =>
    vulnerabilities.post('/cloudsecurity/cspm/vulnerability/runtime-exploit-funnel', data),
  get_management_vulnerable_container: data =>
    vulnerabilities.post('/cloudsecurity/cspm/vulnerability/container-images', data),
  get_management_top_cve: data => vulnerabilities.post('/cloudsecurity/cspm/vulnerability/list', data),
  get_vuln_severity_by_age: data =>
    vulnerabilities.post('/cloudsecurity/cspm/vulnerability/vuln-seveirty-by-age', data),

  get_management_workload_distribution: data =>
    vulnerabilities.post('/cloudsecurity/cspm/vulnerability/workload-distribution', data),
  //

  get_vulnerabilities_by_severity: data => vulnerabilities.post('/cloudsecurity/cspm/vulnerability/timeseries', data),

  get_management_table_data: data => vulnerabilities.post('/cloudsecurity/cspm/vulnerability/details/table', data),
  get_management_table_data_export: data => vulnerabilities.post('/cloudsecurity/cspm/vulnerability/export', data),

  get_management_table_filters: data => vulnerabilities.post('/cloudsecurity/cspm/vulnerability/filters', data),

  get_sbom_table_data: data => vulnerabilities.post('/cloudsecurity/cspm/unified-artifacts/sbom/list', data),
  get_sbom_table_filters: data => vulnerabilities.post('/cloudsecurity/cspm/unified-artifacts/sbom/filters', data),
};

const CompliancePacks = {
  get_selected_compliances: data => compliance_pack.post(`/cloudsecurity/cspm/get_selected_compliance_packs`, { data }),
};

const Code = {
  get_registry_table_data: data => code.post('/registry-scanning/inventory', data),
  get_registry_table_filter: data => code.post('/registry-scanning/property-key-value', data),
  get_registry_table_sideoverlay_data: data => code.post('/registry-scanning/sideoverlay', data),
  get_registry_table_sideoverlay_license_data: data =>
    vulnerabilities.post('/cloudsecurity/cspm/ecr-gar-licenses', data),
  get_registry_table_sideoverlay_license_data_filter_values: data =>
    vulnerabilities.post('/cloudsecurity/cspm/ecr-gar-licenses-filter-values', data),
  get_exception_vul_table_data: data => vulnerabilities.post('/cloudsecurity/iac/vulnerability-exception-list', data),
  get_exception_iac_table_data: data => vulnerabilities.post('/cloudsecurity/iac/iac-exception-list', data),
  get_checkmarx_exception_list: data => vulnerabilities.post('/code_security/checkmarx/checkmarx-list-exception', data),
  get_semgrep_exception_list: data => vulnerabilities.post('/v1/iac/semgrep/list-exception', data),
  get_checkmarx_dast_scan_list: data => vulnerabilities.post('/code_security/checkmarx/list-dast-environments', data),
  get_checkmarx_dast_scan_list_filter: () =>
    vulnerabilities.get('/code_security/checkmarx/list-dast-environments-filter'),
  get_checkmarx_dast_results_list: data => vulnerabilities.post('/code_security/checkmarx/checkmarx-dast', data),
  get_checkmarx_dast_scan_history: data => vulnerabilities.post('/code_security/checkmarx/dast-scan-history', data),
  get_checkmarx_dast_results_list_filter: data =>
    vulnerabilities.post('/code_security/checkmarx/checkmarx-dast-filter', data),
  get_checkmarx_dast_results_details: data =>
    vulnerabilities.post('/code_security/checkmarx/checkmarx-dast-vuln-details', data),
  get_checkmarx_dast_siteTree: data => vulnerabilities.post('/code_security/checkmarx/checkmarx-dast-site-tree', data),
  get_checkmarx_dast_siteTree_endPoint_list: data =>
    vulnerabilities.post('/code_security/checkmarx/checkmarx-dast-endpoint-vulns', data),
  get_checkmarx_dast_deployment_config: () =>
    vulnerabilities.get('/code_security/checkmarx-dast/get-dast-deployment-config'),
  get_checkmarx_dast_deboard_command: data =>
    vulnerabilities.post('/code_security/checkmarx/generate-dast-deboard-command', data),
};

const ApiSecurity = {
  //Overview
  get_api_sec_overview_sensitive_endpoints: data => apiSecurity.post('/overview/sensitive-endpoints', data),
  get_api_sec_overview_endpoint_breakdown: data => apiSecurity.post('/overview/endpoint-breakdown', data),
  get_api_sec_overview_top_owasp_vulnerabilities: data => apiSecurity.post('/overview/top-ten-owasp-vulns', data),
  get_api_sec_overview_top_cwe_categories: data => apiSecurity.post('/overview/top-ten-cwe-categories', data),
  get_api_sec_overview_risky_endpoints: data => apiSecurity.post('/overview/risky-endpoints', data),
  get_api_sec_overview_exposed_unauthed_endpoints: data =>
    apiSecurity.post('/overview/exposed-unauthed-endpoints', data),
  get_api_sec_overview_unauthed_sensitive_endpoints: data =>
    apiSecurity.post('/overview/unauthed-sensitive-endpoints', data),
  get_api_sec_overview_egress_datastore_exposure: data => apiSecurity.post('/overview/egress-datastore-exposure', data),
  get_api_sec_overview_traffic_origin_locations: data => apiSecurity.post('/overview/traffic-origin-locations', data),
  get_api_sec_overview_endpoints_funnel: data => apiSecurity.post('/overview/endpoints-funnel', data),
  get_api_sec_overview_api_sec_detections: data => apiSecurity.v1Post('/inventory/api-sec-detections', data),
  get_api_sec_overview_api_sec_table: data => apiSecurity.v1Post('/inventory/api-details-table', data),
  get_api_sec_overview_api_sec_table_filter_values: data =>
    apiSecurity.v1Post('/inventory/api-details-table-filters', data),
  get_api_sec_overview_api_endpoint_details: data => apiSecurity.v1Post('/inventory/api-endpoint-details', data),

  //Inventory
  get_api_sec_inventory_top_cards: data => apiSecurity.post('/inventory/api-sec-inventory-card', data),
  get_api_sec_inventory_list: data => apiSecurity.post('/api-sec-inventory', data),
  get_api_sec_shadow_apis: data => apiSecurity.post('/overview/shadow-apis', data),
  get_api_sec_inventory_filter_values: data => apiSecurity.post('/api-sec-inv-filter-values', data),
  get_api_sec_inventory_sideoverlay_data: data => apiSecurity.v1Post('/inventory/api-sec-inventory-details', data),
  // Inventory - Resources tab (runtime T-1 workloads/endpoints)
  get_api_sec_inventory_resources: data => apiSecurity.v1Post('/inventory/api-sec-resources', data),
  get_api_sec_inventory_resource_endpoints: data => apiSecurity.v1Post('/inventory/api-sec-resource-endpoints', data),
  // Inventory - runtime endpoint deep-dive (overlay tabs) + workload profile
  get_api_sec_endpoint_details: data => apiSecurity.v1Post('/inventory/api-sec-endpoint-details', data),
  get_api_sec_endpoint_clients: data => apiSecurity.v1Post('/inventory/api-sec-endpoint-clients', data),
  get_api_sec_endpoint_findings: data => apiSecurity.v1Post('/inventory/api-sec-endpoint-findings', data),
  get_api_sec_resource_profile: data => apiSecurity.v1Post('/inventory/api-sec-resource-profile', data),

  //Risk
  get_api_sec_risk_list: data => apiSecurity.post('/risk/api-sec-findings', data),
  get_api_sec_risk_filter_values: data => apiSecurity.post('/risk/api-sec-findings-filter', data),

  //Runtime Findings
  get_api_sec_runtime_findings: data => apiSecurity.post('/runtime-findings/list', data),
  get_api_sec_runtime_findings_filter: data => apiSecurity.post('/runtime-findings/filter', data),
  get_api_sec_runtime_finding_detail: data => apiSecurity.post('/runtime-findings/detail', data),
};

const AiSecurity = {
  //Overview
  get_ai_sec_overview_data: data => aiSecurity.post('/overview', data),
  get_ai_sec_open_issues_trend: data => aiSecurity.post('/open-issues-trend', data),
  get_ai_sec_software_inventory: data => aiSecurity.post('/software-inventory', data),
  get_ai_sec_vulnerabilities_data: data => aiSecurity.post('/vulnerabilities', data),

  //AI MCP
  get_ai_sec_inventory_mcp_servers_summary: data => aiSecurity.post('/mcp-servers/summary', data),
  get_ai_sec_inventory_mcp_servers_tData: data => aiSecurity.post('/mcp-servers', data),
  get_ai_sec_inventory_mcp_servers_tData_filter_values: data => aiSecurity.post('/mcp-servers-filter-values', data),

  //AI Workload
  get_ai_sec_inventory_workloads_summary: data => aiSecurity.post('/ai-workloads/summary', data),
  get_ai_sec_inventory_workloads_tData: data => aiSecurity.post('/ai-workloads', data),
  get_ai_sec_inventory_workloads_tData_filter_values: data => aiSecurity.post('/ai-workloads-filter-values', data),

  //AI Agents
  get_ai_sec_inventory_agents_summary: data => aiSecurity.post('/ai-agents/summary', data),
  get_ai_sec_inventory_agents_tData: data => aiSecurity.post('/ai-agents', data),
  get_ai_sec_inventory_agents_tData_filter_values: data => aiSecurity.post('/ai-agents-filter-values', data),

  //AI Models
  get_ai_sec_inventory_models_summary: data => aiSecurity.post('/ai-models/summary', data),
  get_ai_sec_inventory_models_tData: data => aiSecurity.post('/ai-models', data),
  get_ai_sec_inventory_models_tData_filter_values: data => aiSecurity.post('/ai-models-filter-values', data),
};

const FinOps = {
  get_finOps_discovery_card: data => finOps.post('/discovery-card', data),
  get_finOps_optimization_card: data => finOps.post('/optimization-card', data),
  get_finOps_resource_type_breakdown: data => finOps.post('/resource-type-breakdown', data),
  get_finOps_environment_breakdown: data => finOps.post('/environment-breakdown', data),
  get_finOps_top_subscriptions: data => finOps.post('/top-subscriptions', data),
  get_finOps_opportunities: data => finOps.post('/opportunities', data),
  get_finOps_opportunities_filter_values: data => finOps.post('/opportunities-filter-values', data),
  get_finOps_opportunities_resources: data => finOps.post('/opportunities-resources', data),
  get_finOps_resource_graph: data => finOps.post('/resource-graph', data),
  get_finOps_score: data => finOps.post('/score', data),
  get_finOps_cost_trend: data => finOps.post('/cost-trend', data),
  get_finOps_cur_integration_command: data => finOps.post('/cur-integration-command', data),
};

const Risk = {
  risk_overtime_cards_data: data => risk.post(`/cloudsecurity/cspm/risk1.2/risk_overtime_cards`, data),
  risk_overtime_main_data: data => risk.post(`/cloudsecurity/cspm/risk1.2/risk_overtime_main`, data),
  security_score: data => risk.post(`/cloudsecurity/cspm/security-score`, { data }),
  risk_resource_counts: data => risk.post(`/cloudsecurity/cspm/risk-resource-counts`, { data }),
  security_score_graph: data => risk.post(`/cloudsecurity/cspm/security-score-graph`, { data }),
  risk_alerts_severity: data => risk.post(`/cloudsecurity/cspm/risk-alerts-severity`, { data }),
  risk_attack_path_graph_cards: data => risk.post(`/cloudsecurity/cspm/risk_attack_path_graph_cards`, data),
  risk_category_tdata: data => risk.post(`/cloudsecurity/cspm/risk1.2/risk_category_tdata`, data),
  risk_expansion: data => risk.post(`/cloudsecurity/cspm/risk1.2/risk_expansion`, data),
  last_update: data => risk.post(`/cloudsecurity/cspm/risk1.2/last_update`, data),
  risk_category_keys: data => risk.post(`/cloudsecurity/cspm/risk1.2/risk_category_keys`, { data }),
  risk_category_keys_values: data => risk.post(`/cloudsecurity/cspm/risk1.2/risk_category_keys_values`, data),
  export_risk_category_tdata: data => risk.post(`/cloudsecurity/cspm/risk1.2/export_risk_category_tdata`, { data }),
};
const SecurityScore = {
  improvement_plan: data => risk.post(`/v1/securityscore/improvement-plan`, data),
  composition: data => risk.post(`/v1/securityscore/composition`, data),
  trend: data => risk.post(`/v1/securityscore/trend`, data),
};

const Dashboard_New = {
  get_dashboards_list: data => dashboard_new.get(`/custom-dashboard/dashboards`, { data }),
  save_dashboard_cards: data => dashboard_new.post('/custom-dashboard/cards/save', data),
  get_security_score: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/security_score`, { data }),
  get_risk_trend: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/risk_trend`, { data }),
  get_compliance: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/compliance`, { data }),
  get_threats: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/threats`, { data }),
  get_vulnerabilities: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/vulnerabilities`, { data }),
  get_compliance_posture: data =>
    dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/compliance_posture`, { data }),
  get_internet_exposed_resources: data =>
    dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/internet_exposed_resources`, { data }),
  get_top_3_risk_recommendations: data =>
    dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/top_3_risk_recommendations`, { data }),
  get_inventory_card: ({ scope, environments, cloud_provider, regions, assessment_time_filter, date_filter }) =>
    dashboard_new.post('/cloudsecurity/cspm/main_dashboard1.1/inventorycard', {
      data: {
        scope,
        environments,
        cloud_provider,
        regions,
        assessment_time_filter,
        date_filter,
      },
    }),
  get_toptriggered_data: ({
    scope,
    environments,
    rule_type,
    detection_type,
    cloud_provider,
    assessment_time_filter,
    date_filter,
  }) =>
    dashboard_new.post('/cloudsecurity/cspm/main_dashboard1.1/triggeredentitiescard', {
      scope,
      environments,
      rule_type,
      detection_type,
      cloud_provider,
      assessment_time_filter,
      date_filter,
    }),
  get_threats_graph_data: ({ scope, environments, cloud_provider, date_filter }) =>
    dashboard_new.post('/cloudsecurity/cspm/main_dashboard1.1/threatanomalygraph', {
      data: {
        scope,
        environments,
        cloud_provider,
        date_filter,
      },
    }),
  get_identity_security_posture: data => dashboard_new.post(`/identity_dashboard_cards`, data),
  get_regions: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/regions`, { data }),
  get_resource_trend: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/resource_trend`, { data }),
  get_last_updated: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/last_updated`, { data }),
  get_cq_shield_priority: ({ scope, environments, cloud_provider, date_filter, timezone, assessment_time_filter }) =>
    dashboard_new.post('/cloudsecurity/cspm/main_dashboard1.2/cq-shield-priority', {
      data: { scope, environments, cloud_provider, date_filter, timezone, assessment_time_filter },
    }),
  get_open_threat_anamoly: data => dashboard_new.post('/cloudsecurity/cspm/cloud_events_1.2/threats', data),
  get_prioritization_funnel: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/pfunnel`, data),
  get_latest_vulnerabilities: () => dashboard_new.get(`/cloudsecurity/cspm/vulnerability/latest-published`),
  get_top_mitre_attack: data => dashboard_new.post(`/cloudsecurity/cspm/main_dashboard1.1/mitre_attack_top_5`, data),

  // Custom Dashboard APIs
  get_dashboard_cards: id => dashboard_new.get(`/custom-dashboard/cards?dashboard_id=${id}`),
  create_dashboard_card: data => dashboard_new.post('/custom-dashboard/cards', data),
  update_dashboard_card: data => dashboard_new.post(`/custom-dashboard/cards/update`, data),
  delete_dashboard_card: cardId => dashboard_new.del(`/custom-dashboard/cards/${cardId}`),
  get_field_suggestions: data => dashboard_new.post('/custom-dashboard/field-suggestions', data),
  get_top_5_eol: data => dashboard_new.post(`/cloudsecurity/cspm/unified-artifacts/eol/top-outdated`, data),
  get_eol_table_data: data => dashboard_new.post(`/cloudsecurity/cspm/unified-artifacts/eol/list`, data),
  get_eol_table_filter_values: data => dashboard_new.post(`/cloudsecurity/cspm/unified-artifacts/eol/filters`, data),
};
const Inventory_Resources = {
  inventory_resources_list: data => inventory.post(`/cloudsecurity/cspm/inventory_resources_list`, data),
  inventory_dynamic_columns: data => inventory.post(`/cloudsecurity/cspm/inventory/dynamic_columns`, data),
  list_property_value: data => inventory.post(`/cloudsecurity/cspm/list_property_values`, { data }),
  service_category_list: data => inventory.post(`/cloudsecurity/cspm/service_category_list`, { data }),
  get_internet_exposed_path: data => requests.post(`/cloudsecurity/cspm/internet-expose-path`, data),
  get_ecr_deploy_path: data => requests.post(`/visualizer/image-deploy-graph`, data),
  get_assessment_time_filter: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/assessment_time_filter`, { data }),
  get_inventory_side_overlay_tab_counts: data =>
    requests.post(`/cloudsecurity/cspm/inventory/side_overlay/tab_counts`, data),
  // Overview tab of the side overlay: the resource's relationship graph and its risk analysis summary.
  get_resource_graph: data => requests.post(`/visualizer/resource-graph`, data),
  get_resource_risk: data => requests.post(`/visualizer/resource-risk`, data),
};
// remediation
const Reports = {
  get_reports_property_values: data => reports.post(`/remediation_property_values`, data),
  get_table_data: data => reports.post(`/remediation-reports`, data),
  remediation_config: data => reports.post(`/remediation-config`, data),
};
const Policy = {
  get_policy_service_category: data => policy.post(`/event-filter-service-category-policies`, data),
  get_policy_property_values: data => policy.post(`/fetch-policy-values`, { data }),
  get_policy_property_keys: data => policy.post(`/fetch-policy-keys`, { data }),
  get_table_data: data => policy.post(`/fetch-policy`, data),
};
const Inventory_Overview = {
  cloud_provider: data => overview.post(`/cloudsecurity/cspm/inventory/cloud_provider`, { data }),
  top_service_category: data => overview.post(`/cloudsecurity/cspm/inventory/top_service_category`, { data }),
  resource_trend: data => overview.post(`/cloudsecurity/cspm/inventory/resource_trend`, { data }),
  health_score_breakdown: data => overview.post(`/cloudsecurity/cspm/inventory/health_score_breakdown`, { data }),
  resource_compliance: data => overview.post(`/cloudsecurity/cspm/inventory/resource_compliance`, { data }),
  identity_risk: data => overview.post(`/cloudsecurity/cspm/inventory/identity_risk`, { data }),
  get_internet_exposed_path: data => requests.post(`/cloudsecurity/cspm/internet-expose-path`, data),
  alerts_by_severity: data => overview.post(`/cloudsecurity/cspm/inventory/alerts_by_severity`, data),
  resource_compliance_trends: data =>
    overview.post(`/cloudsecurity/cspm/inventory/resource_compliance_trends`, { data }),
  top_non_complianct_resources: data =>
    overview.post(`/cloudsecurity/cspm/inventory/top_non_complianct_resources`, { data }),
  last_updated: data => overview.post(`/cloudsecurity/cspm/inventory/last_updated`, { data }),
  // get_assessment_time_filter: data =>
  //   requests.post(`/cloudsecurity/cspm/compliance_v1.1/assessment_time_filter`, { data }),
};
const Inventory_Resources_Card = {
  all_resource_page: data => inventory_resources_card.post(`/cloudsecurity/cspm/all-resource-page`, { data }),
};
const Key_Insights = {
  serverless_functions: data => key_insights.post(`/cloudsecurity/cspm/inventory/serverless_functions`, data),
  cloud_storage: data => key_insights.post(`/cloudsecurity/cspm/inventory/cloud_storage`, data),
  get_assessment_time_filters: data =>
    requests.post(`/cloudsecurity/cspm/compliance_v1.1/assessment_time_filter`, { data }),
};
const Edit_Enviroment = {
  get_registry_data: data => edit_enviroment.post('/cloudsecurity/cspm/registry_table', { data }),
  get_list_repo: data => edit_enviroment.post('/cloudsecurity/iac/list_repository', data),
  get_environment_data: data => edit_enviroment.post(`/cloudsecurity/cspm/environment-data`, { data }),
  get_environment_update_command: data =>
    edit_enviroment.post(`/cloudsecurity/cspm/environment-update-command`, { data }),
  generate_command: data => edit_enviroment.post(`/cloudsecurity/cspm/generate-command`, { data }),
  update_environment: data => edit_enviroment.post(`/cloudsecurity/cspm/update-environment`, { data }),
  check_subscribed_modules: data => edit_enviroment.post(`/cloudsecurity/cspm/check_subscribed_modules`, data),
  update_eks_existing_resources: data => edit_enviroment.post(`/cloudsecurity/cspm/eks_existing_resources`, { data }),
  get_eks_existing_resources: account_id =>
    edit_enviroment.post(`/cloudsecurity/cspm/eks_existing_resources`, { data: { account_id: account_id } }),

  check_eligibility: data => edit_enviroment.post(`/cloudsecurity/cspm/check-eligibility`, { data }),
  get_helm_command: data => edit_enviroment.post(`/cloudsecurity/cspm/generate-helm-command`, data),
  gcp_onboarding_command: data => edit_enviroment.post(`/cloudsecurity/cspm/gcp-onboarding/manual-scan`, data),
  gcp_deboarding_command: data => edit_enviroment.post(`/cloudsecurity/cspm/gcp/generate-deboarding-command`, data),
  check_cloud_formation: data => requests.post('/cloudsecurity/cspm/generate-cloudformation-command', data),
  check_api_security_t1_cloud_formation: data =>
    requests.post('/cloudsecurity/cspm/gen-api-security-t1-cloudformation-command', data),
  get_workload_resource: data => edit_enviroment.post(`/cloudsecurity/cspm/sync-ec2-instances`, data),
  get_vpc_config_data: data => edit_enviroment.post(`/cloudsecurity/cspm/ec2-vpc-configuration`, data),
};

const Malware = {
  get_last_update: data => malware.post(`/cloudsecurity/cspm/malware/last-update`, { data }),
  get_kpi_data: data => malware.post(`/cloudsecurity/cspm/malware/kpi-data`, { data }),
  get_problem_file_data: data => malware.post(`/cloudsecurity/cspm/malware/problem-files`, { data }),
  get_scan_info: data => malware.post(`/cloudsecurity/cspm/malware/scan-info`, { data }),
  get_bucket_protection_status: data => malware.post(`/cloudsecurity/cspm/malware/bucket-protection-status`, { data }),
  get_active_bucket: data => malware.post(`/cloudsecurity/cspm/malware/active-buckets`, { data }),
  get_regions_filter_data: data => malware.post(`/cloudsecurity/cspm/malware/regions-filter-data`, { data }),
  get_malware_data: data => malware.post(`/cloudsecurity/cspm/inventory/side_overlay/malware`, data),
  get_finding_table_data: data => malware.post(`/cloudsecurity/cspm/malware/finding-table-data`, { data }),
  get_bucket_protection_table_data: data =>
    malware.post(`/cloudsecurity/cspm/malware/bucket-protection-table-data`, { data }),
  get_finding_property_filter: data => malware.post(`/cloudsecurity/cspm/malware/finding-property-filter`, { data }),
  get_bucket_protection_property_filter: data =>
    malware.post(`/cloudsecurity/cspm/malware/bucket-protection-property-filter`, { data }),
  get_secrets_overview: data => malware.post(`/cloudsecurity/cspm/malware/secrets-overview`, { data }),
  get_data_classfication: data => malware.post(`/cloudsecurity/cspm/malware/finding/data-classification`, { data }),
};

const DataSecurity = {
  get_pii_files: data => data_security.post(`/cloudsecurity/cspm/malware/pii-files`, data),
  get_live_secrets: data => data_security.post(`/cloudsecurity/cspm/malware/live-secrets`, { data }),
  get_top_active_actor: data => data_security.post('/cloudsecurity/cspm/malware/top-active-actors', { data }),
  get_asset_overview: data => data_security.post('/cloudsecurity/cspm/malware/asset-overview', { data }),
  get_alert_data: data => data_security.post('/cloudsecurity/cspm/malware/alert_api', data),
  get_data_distribution: data => data_security.post('/cloudsecurity/cspm/malware/data-distribution', { data }),
  get_sensitive_data: data => data_security.post('/cloudsecurity/cspm/malware/sensitive-data', { data }),
  get_attack_path_distribution_data: data =>
    data_security.post('/cloudsecurity/cspm/malware/attack-path-distribution', data),
  get_top_five_attack_path: data => data_security.post('/cloudsecurity/cspm/malware/top-five-attack-path', data),
  get_data_security_table_data: data => data_security.post('/cloudsecurity/cspm/malware/resource-details', data),
  get_data_security_table_filter_data: data =>
    data_security.post('/cloudsecurity/cspm/malware/resource-details-property-filter', data),
};

const DataBaseSecurity = {
  get_table_data_database_security: data => data_base_security.post('/v1/database_security/mongo-atlas-findings', data),
  get_table_filter_data_database_security: data =>
    data_base_security.post('/v1/database_security/mongo-atlas-findings-filter', data),
  get_overview_top_findings: () => data_base_security.get('/v1/database_security/overview/top-findings'),
  get_overview_severity_breakup: () => data_base_security.get('/v1/database_security/overview/severity-breakup'),
  get_overview_real_time_activity_feed: data =>
    data_base_security.post('/v1/database_security/overview/real-time-activity-feed', data),
  trigger_rescan_database_security: data =>
    data_base_security.post('/v1/database_security/mongo-atlas-findings/trigger-rescan', data),
  create_finding_exception_database_security: data =>
    data_base_security.post('/v1/database_security/finding-exception', data),
  get_finding_exception_list_database_security: data =>
    data_base_security.post('/v1/database_security/finding-exception-list', data),
  edit_revoke_finding_exception_database_security: data =>
    data_base_security.post('/v1/database_security/edit-revoke-finding-exception', data),
};

const Jira_Notification = {
  get_last_update: data => jira_notifications.post(`/cloudsecurity/cspm/jira/last-update`, { data }),
  get_table_data_jira: data => jira_notifications.post(`/jira/dashboard_data`, data),
  get_org_id: data => jira_notifications.post(`/jira/org_id`, data),
  get_issue_id: data => jira_notifications.post(`/jira/issue-id`, data),
  get_jira_projects: data => jira_notifications.post('/jira/projects', data),
  get_ticket_details: data => jira_notifications.post(`/jira/dashboard_data_asset`, data),
  get_project_statuses: data => jira_notifications.post(`/jira/project-statuses`, data),
  get_project_info: data => jira_notifications.post(`/jira/project_info`, data),
  dashboard_ticket_update_info: data => jira_notifications.post(`/jira/dashboard_ticket_update_info`, data),
  get_filter_issues: data => jira_notifications.post(`/jira/filter-issues`, data),
  edit_jira_tickets: data => jira_notifications.post(`/jira/update_ticket`, data),
};
const Data_Classification = {
  get_side_overlay_details: data =>
    data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/details', data),
  get_side_overlay_alerts: data => data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/alerts', data),
  get_side_overlay_misconfigurations: data =>
    data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/misconfigurations', data),
  get_side_overlay_vulnerabilities: data =>
    data_classification.post('/cloudsecurity/cspm/inventory/vulnerablities', data),
  get_side_overlay_risks: data => data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/risks', data),
  get_side_overlay_content: data =>
    data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/contents', data),
  get_side_overlay_events: data => data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/events', data),
  get_side_overlay_entity_type: data =>
    data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/entity_type', data),
  get_side_overlay_active_identities: data =>
    data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/active_identities', data),
  get_inventory_resources_list_side_overlay: data =>
    data_classification.post('/cloudsecurity/cspm/inventory_resources_list_side_overlay', data),
  get_resource_configuration: data => data_classification.post('/cloudsecurity/cspm/resource_configuration', data),
  get_secrets: data => data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/secrets', data),
  get_side_overlay_investigation: data =>
    data_classification.post('/cloudsecurity/cspm/inventory/side_overlay/investigation', data),
};
const repoScan = {
  get_side_overlay_details: data =>
    data_classification.post('/cloudsecurity/iac/side_overlay_repository_extradetails', data),
  get_repository_code_iac: data => data_classification.post('/cloudsecurity/iac/repository_code_iac', data),
  get_repository_code_iac_filter: data =>
    data_classification.post('/cloudsecurity/iac/repository_code_iac/filter', data),
  get_repository_skip_file: data => data_classification.post('/cloudsecurity/iac/scan-history-report-skipfile', data),
  get_finding_data: data => data_classification.post('/cloudsecurity/iac/iac_repository_iac_code_sideoverlay', data),
  get_secret_data: data => data_classification.post('/cloudsecurity/iac/repository_secrets', data),
  get_secret_filter_data: data => data_classification.post('/cloudsecurity/iac/repository_secrets/filter', data),
  get_repository_vulnerablities_data: data =>
    data_classification.post('/cloudsecurity/iac/repository_vulnerablities', data),
  get_repository_vulnerablities_filter_data: data =>
    data_classification.post('/cloudsecurity/iac/repository_vulnerablities/filter', data),
  get_repository_side_overlay_trends: data =>
    data_classification.post('/cloudsecurity/iac/repository_side_overlay_trends', data),
  get_repository_code_iac_risk_count: data =>
    data_classification.post('/cloudsecurity/iac/repository_code_iac_risk_count', data),
  get_repository_details_all_scans: data => data_classification.post('/cloudsecurity/iac/scan-history', data),

  get_list_repo: data => data_classification.post('/cloudsecurity/iac/repository', data),
  get_code_last_update: data => data_classification.post('/cloudsecurity/iac/last_update', data),
  get_list_compliance_framework: data => data_classification.post('/cloudsecurity/iac/complienc_framework_list', data),
  get_list_alerts: data => data_classification.post('/v1/iac/alerts/list', data),
  get_list_repository_filter: data => data_classification.post('/cloudsecurity/iac/listrepository_filter', data),
  get_list_alerts_filter: data => data_classification.post('/v1/iac/alerts/table_filter', data),
  get_list_alerts_by_risk_level: data => data_classification.post('/v1/iac/alerts/by-risk-level', data),
  get_list_alerts_by_category: data => data_classification.post('/v1/iac/alerts/by-category', data),
  get_alerts_over_time: data => data_classification.post('/v1/iac/alerts/over-time', data),
  get_alerts_sideoverlay: data => data_classification.post('/v1/iac/alerts/code-scanning-finding', data),
  get_code_scanning_violated_control: data =>
    data_classification.post('/cloudsecurity/iac/code_scanning_violated_control', data),
  get_repo_most_issues: data => data_classification.post('/code_security/dashboard/repo-with-most-issues', data),
  get_compliance_over_score: data => data_classification.post('/code_security/dashboard/compliance-overview', data),
  get_issues_by_severity: data => data_classification.post('/code_security/dashboard/vulnerability-by-severity', data),
  get_validate_providers: () => data_classification.get('/code_security/checkmarx/validate_providers'),
  get_checkmarx_list_repos: data => data_classification.post('/code_security/checkmarx/list-repos', data),
  get_checkmarx_sast_list: data => data_classification.post('/code_security/checkmarx/checkmarx-sast', data),
  get_checkmarx_sast_details: data => data_classification.post('/code_security/checkmarx/checkmarx-sast-details', data),
  get_checkmarx_sast_filter: data => data_classification.post('/code_security/checkmarx/checkmarx-sast-filter', data),
  get_checkmarx_container_list: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-container-images', data),
  get_checkmarx_container_filter: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-container-images-filter', data),
  get_checkmarx_container_layers_list: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-container-layers', data),
  get_checkmarx_container_packages_list: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-container-packages', data),
  get_checkmarx_container_packages_list_filter: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-container-packages-filter', data),
  get_checkmarx_sca_packages_list: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-sca-packages', data),
  get_checkmarx_sca_packages_filter: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-sca-packages-filter', data),
  get_checkmarx_sca_risks_list: data => data_classification.post('/code_security/checkmarx/checkmarx-sca-risks', data),
  get_checkmarx_sca_risks_filter: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-sca-risks-filter', data),
  get_checkmarx_sca_licenses_list: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-sca-licenses', data),
  get_checkmarx_sca_licenses_filter: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-sca-licenses-filter', data),
  get_checkmarx_sca_legal_risks_list: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-sca-legal-risks', data),
  get_checkmarx_sca_legal_risks_filter: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-sca-legal-risks-filter', data),
  get_checkmarx_api_list: data => data_classification.post('/code_security/checkmarx/checkmarx-api-security', data),
  get_checkmarx_api_filter: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-api-security-filter', data),
  get_checkmarx_api_sideoverlay_details: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-api-risk-details', data),
  get_checkmarx_api_sideoverlay_yaml_source_code: data =>
    data_classification.post('/code_security/checkmarx/checkmarx-source-code', data),
  get_checkmarx_iac_list: data => data_classification.post('/code_security/checkmarx/checkmarx-iac', data),
  get_checkmarx_iac_filter: data => data_classification.post('/code_security/checkmarx/checkmarx-iac-filter', data),
  get_semgrep_rules_list: () => data_classification.get('/v1/iac/semgrep/rules/list'),
  get_semgrep_sideoverlay_details: data => data_classification.post('/v1/iac/semgrep/side-overlay-details', data),
  get_semgrep_sideoverlay_tabs_filter_options: data =>
    data_classification.post('/v1/iac/semgrep/side-overlay-filter-options', data),
  get_semgrep_api_sideoverlay_yaml_source_code: data => data_classification.post('/v1/iac/semgrep/source-code', data),
  get_semgrep_sast_sideoverlay_details: data => data_classification.post('/v1/iac/semgrep/sast-details', data),
};

const ViperAI = {
  get_conversation_id: data => viper_ai.post(`/v1/ai_chat`, { data }),
  get_viper_ai_chat_data: (data, query) => viper_ai_chat.post(`/v1/ai_chat`, data, query),
  get_list_conversation: ({ limit = 25, skip = 0 } = {}) => viper_ai.get(`/v1/ai_chat`, limit, skip),
  get_viper_ai_chat_history: id => viper_ai_chat.get(`/v1/ai_chat`, id),
  delete_conversation: id => viper_ai_chat.del(`/v1/ai_chat`, id),
  get_message_progress: (conversationId, messageId) =>
    viper_ai_chat.get_progress(`/v1/ai_chat`, conversationId, messageId),
  get_conversation_search: search_keyword => viper_ai_chat.get_search(`/v1/ai_chat`, search_keyword),
  get_suggested_questions: () => viper_ai_chat.normal_get(`/v1/ai_chat/suggested-questions`),
  submit_feedback: (conversationId, messageId, action, comment) =>
    viper_ai_chat.post_feedback(`/v1/ai_chat`, conversationId, messageId, { action, comment }),
};
const Tenant_Config = {
  get_config: () => requests.post('/cloudsecurity/cspm/tenant-config-status'),
};
const Account = {
  get_groups: () => requests.post('/user_group_info'),
  validate_login_credentials: ({ apiUrl, email, password }) =>
    requests.post('/validate-credentials', {
      apiUrl,
      email,
      password,
    }),
  /**
   *
   * @param {*} param.accountId The environment id
   * @returns
   */
  get_shield_report_settings: ({ accountId }) =>
    requests.post('/save-report-info', {
      accountId,
    }),
  /**
   *
   * @param {*} param Object param
   * @param {*} param._ls localStorage content as object
   * @param {*} param.apiUrl The API base url
   * @param {*} param.baseUrl The base url of the dashboard
   * @param {*} param.accountId The environment id
   * @param {*} param.orgInfo Ignore for now
   * @param {*} param.timeRange 7d, 30d, 90d ,365d
   * @param {*} param.loginInfo { "email": LOGIN_EMAIL, "password": LOGIN_PASSWORD }
   * @param {*} param.mainInfo { "to": [EMAIL_ADDRESSES], "cc": [], "bcc": [] }
   * @param {*} param.customInfo { envName, primaryTag, provider }
   * @param {*} param.createdBy { name: string; email: string }
   * @returns
   */
  save_shield_report_settings: ({
    _ls,
    apiUrl,
    baseUrl,
    accountId,
    orgInfo,
    timeRange,
    loginInfo,
    mailInfo,
    customInfo,
    createdBy,
    isEnabled,
  }) =>
    requests.post('/save-report-info', {
      _ls,
      apiUrl,
      baseUrl,
      accountId,
      orgInfo,
      timeRange,
      loginInfo,
      mailInfo,
      customInfo,
      createdBy,
      isEnable: isEnabled,
    }),

  /**
   *
   * @param {*} param Object param
   * @param {*} param._ls localStorage content as object
   * @param {*} param.apiUrl The API base url
   * @param {*} param.baseUrl The base url of the dashboard
   * @param {*} param.accountId The environment id
   * @param {*} param.orgInfo Ignore for now
   * @param {*} param.timeRange 7d, 30d, 90d, 365d
   * @param {*} param.loginInfo { "email": LOGIN_EMAIL, "password": LOGIN_PASSWORD }
   * @param {*} param.mainInfo { "to": [EMAIL_ADDRESSES], "cc": [], "bcc": [] }
   * @param {*} param.customInfo null
   * @returns
   */
  update_shield_report_settings: ({
    apiUrl,
    baseUrl,
    accountId,
    orgInfo,
    timeRange,
    mailInfo,
    isEnabled,
    customInfo,
  }) =>
    requests.post('/save-report-info', {
      accountId,
      updateInfo: {
        apiUrl,
        baseUrl,
        orgInfo,
        timeRange,
        mailInfo,
        isEnable: isEnabled,
        customInfo,
      },
    }),

  // Only call this once settings are saved using the above endpoints.
  send_report_now: ({ accountId, timeRange }) => requests.post('/download-instant-report', { accountId, timeRange }),
};

const AgentPurposeBot = {
  health: () => requests.get('/v1/health'),
  list_bots: () => requests.get('/v1/bots'),
  bot_details: bot_id => requests.get(`/v1/bots/${bot_id}`),
  run_bot: (bot_id, data) => requests.post(`/v1/bots/${bot_id}/run`, { data }),
  run_with_supervisor: data => requests.post('/v1/bots/run', { data }),
  stream_bot: (bot_id, data) => requests.post(`/v1/bots/${bot_id}/stream`, { data }),
};

export default {
  AgentPurposeBot,
  Tenant_Config,
  Misc,
  Inventory_Resources,
  Jira_Notification,
  Data_Classification,
  Account,
  Malware,
  DataSecurity,
  DataBaseSecurity,
  Reports,
  repoScan,
  Policy,
  Edit_Enviroment,
  Inventory_Overview,
  Users,
  Inventory_Resources_Card,
  Kubernetes,
  Code,
  ApiSecurity,
  AiSecurity,
  FinOps,
  Key_Insights,
  Dashboard_New,
  CompliancePacks,
  Vulnerabilites,
  Risk,
  SecurityScore,
  CloudEvents,
  Compliance,
  CustomFramework,
  Integration,
  notification_logs,
  notification_setting,
  Auth,
  Clients,
  Cspa,
  Phishing,
  ClientDashboard,
  BulkRemediation,
  OCR,
  Rules,
  Environment,
  Environment_Monitoring,
  Identity,
  Visualization,
  Visualization_Filter,
  AttackPathAnalysis,
  AttackPathsV2,
  API_ROOT,
  ViperAI,
  // Cookie-based auth: tokens are handled via HTTP-only cookies, not client-side storage
  // These are kept as no-ops for backward compatibility
  setToken: () => {},
  setRefreshToken: () => {},
};
